import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { LandingService } from '../landing/landing.service';

import { AuthService } from './auth.service';
@Injectable()
export class MeService {

    constructor(
        private _capabilityEngineService: CapabilityEngineService,
        private _landingService: LandingService,
        private _authService: AuthService,
        private _router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let promise = new Promise((resolve, reject) => {
            // if (!this._capabilityEngineService.capabilities) {
                this._landingService.meService()
                    .subscribe((res: any) => {
                        this._capabilityEngineService.saveCapabilities(res.user);
                        localStorage.setItem("userName", res.user.name)
                        localStorage.setItem("userEmail", res.user.email)
                        localStorage.setItem("teams", JSON.stringify(res.user.teams))
                        resolve(true);
                    }, (err) => {
                        resolve(false)
                        console.log(err);
                        localStorage.clear();
                        this._authService.clearAllCookies();
                        this._router.navigateByUrl('/signin');
                    });
            // } else {
            //     resolve(true);
            // }
        });
        return promise;
    }
}





// WEBPACK FOOTER //
// ./src/app/auth/me.service.ts